<script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import MenuDropDown from '@/components-deprecated/MenuDropDown.vue';
import Auth from '@/services/auth';
import { useRootStore } from '@/stores';
import { useStageSwitcher } from './composables/useStageSwitcher';

// Props
const props = defineProps({
    showStaffNav: {
        type: Boolean,
        default: false
    }
});

// Setup
const router = useRouter();
const rootStore = useRootStore();
const { stageSwitcherMenuItem, canAccessStageSelector } = useStageSwitcher();

// Data
const dropdownData = ref([
    {
        name: 'All Settings',
        onclick: handleSettings,
        showInStaffNav: false
    },
    {
        name: 'Logout',
        onclick: handleLogout,
        showInStaffNav: true
    }
]);

// Computed properties
const user = computed(() => rootStore.user);
const userIsLoggedIn = computed(() => rootStore.userIsLoggedIn);
const menuItems = computed(() => {
    let items = [...dropdownData.value];

    if (canAccessStageSelector.value === true) {
        items = [stageSwitcherMenuItem.value, ...items];
    }
    if (props.showStaffNav) {
        items = items.filter((item) => item.showInStaffNav === true);
    }
    return items;
});

// Methods
function firstSym(text) {
    return text && text.charAt ? text.charAt(0).toUpperCase() : '';
}

function handleSettings() {
    router.push({ name: 'Settings' });
}

function handleLogout() {
    Auth.logout();
    router.push({ name: 'Login' });
}
</script>

<template>
    <div class="nav-user-profile">
        <MenuDropDown :actions="menuItems" arrowEnabled>
            <button
                v-if="userIsLoggedIn"
                tabindex="0"
                @click="() => {}"
                class="user"
                aria-label="Settings menu"
            >
                <div>
                    <div class="user__avatar">
                        <template v-if="user.displayName">
                            <span class="user__initials">{{ firstSym(user.firstName) }}</span>
                            <span class="user__initials">{{ firstSym(user.lastName) }}</span>
                        </template>
                        <template v-else>
                            <span>N/A</span>
                        </template>
                    </div>
                </div>
            </button>
        </MenuDropDown>
    </div>
</template>

<style lang="scss" scoped>
.nav-user-profile {
    margin-left: 8px;
}

.user {
    display: flex;
    align-items: center;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    font-size: 12px;

    &:focus {
        outline: 2px solid var(--edsights-blue, #0074cc);
    }
}

.user__avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: #f3f5f8;
    color: var(--dark-gray, #333);
    font-weight: bold;
}

.user__initials {
    font-size: 1.2rem;
}
</style>
